import React, { useEffect, useState, memo } from "react"
import "./PRSRecordStatus.scss"

const PRSRecordStatus = (props) => {
  const [iconName, setIconName] = useState("")
  const [status, setStatus] = useState("Not Yet Started")

  useEffect(() => {
    if (props.data) {
      if (props.data.is_cancelled === true) {
        setStatus("Upload Cancelled")
      } else if (props.data.is_processing === true) {
        setStatus("Uploading")
      } else if (props.data.is_queued === true) {
        setStatus("Not Yet Started")
      } else if (props.data.upload_failed === true) {
        setStatus("Failed")
      } else if (props.data && props.data.upload_report && props.data.upload_report.recordStatus) {
        let { recordStatus } = props.data.upload_report
        setStatus(recordStatus)
      }
    }
  }, [props.data])

  useEffect(() => {
    switch (status) {
      case "Uploading":
        setIconName("far fa-redo")
        break
      case "Not Yet Started":
        setIconName("fas fa-clock")
        break
      case "Failed":
        setIconName("fas fa-minus-circle")
        break
      case "Upload Cancelled":
        setIconName("far fa-ban")
        break
      case "Release Cancelled":
        setIconName("far fa-ban")
        break
      default:
        setIconName("fas fa-check-circle")
    }
  }, [status])

  const getColor = (variant) => {
    switch (variant) {
      case "Not Yet Started":
      case "Uploading":
        return "prs-record-info"
      case "Failed":
      case "Upload Cancelled":
      case "Release Cancelled":
        return "prs-record-error"
      default:
        return "prs-record-success"
    }
  }

  return (
    <div className="prs-record-status-container">
      <i
        className={`${iconName} ${status === "Uploading" ? "animation-mixin" : "no-animation-mixin"} ${getColor(
          status
        )} prs-record-status-icon`}
      />
      {status}
      {props.data.receipt_url && (
        <a
          href={props.data.receipt_url}
          target="_blank"
          className="view-receipt-link"
        >
          View Receipt
        </a>
      )}
    </div>
  )
}

export default memo(PRSRecordStatus)
